import React, { useEffect, useState } from 'react'
import { MetaSeo } from '@next-nx/shared-ui/atoms'
import {
  Header,
  Footer,
  Toolbar,
  Prefooter,
  FormRichiestaPreventivoModal,
  RichiestaPreventivoThankYouModal,
} from '@next-nx/shared-ui/organisms'
import styles from './Page.module.sass'
import { useCreateRichiestaContattoMutation } from '@next-nx/shared-graphql/unipolrental'

interface Props {
  pagina: any
  item?: any
  header?: any
  prefooter?: boolean
  footer?: any
  children: React.ReactNode
  className?: string
  contentClassName?: string
  selfCanonical?: boolean
}

const Page = (props: Props) => {
  const {
    pagina = {},
    header = undefined,
    prefooter = true,
    footer = undefined,
    item = {},
    children = null,
    className = '',
    contentClassName = '',
    selfCanonical = false,
  } = props

  const [openFormRichiestaPreventivoModal, setOpenFormRichiestaPreventivoModal] = useState(false)
  const [openRichiestaPreventivoThankYouModal, setOpenRichiestaPreventivoThankYouModal] =
    useState(false)
  const [statusRichiestaPreventivoThankYouModal, setStatusRichiestaPreventivoThankYouModal] =
    useState<string | undefined>()

  const [createRichiestaContattoMutation] = useCreateRichiestaContattoMutation()

  const [scrollY, setScrollY] = useState(0)
  const handleScroll = () => {
    setScrollY(window.scrollY)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    if (window.scrollY > 0) document.body.classList.add('w-scrolled')
    else document.body.classList.remove('w-scrolled')
  }, [scrollY])

  return (
    <div className={styles.pageWrap}>
      <Toolbar page={pagina} item={item} />
      <div className={`${styles.page} page ${className}`}>
        {pagina?.seo && <MetaSeo selfCanonical={selfCanonical} seo={pagina.seo} />}
        {header ? header : <Header setopenPreventivoModal={setOpenFormRichiestaPreventivoModal} />}
        <div className={`${styles.content} ${contentClassName}`}>{children}</div>
        {prefooter ? <Prefooter /> : <></>}
        {footer ? footer : <Footer />}
      </div>
      <FormRichiestaPreventivoModal
        open={openFormRichiestaPreventivoModal}
        setOpen={setOpenFormRichiestaPreventivoModal}
        mutation={createRichiestaContattoMutation}
        onSubmit={(status) => {
          setOpenFormRichiestaPreventivoModal(false)
          setOpenRichiestaPreventivoThankYouModal(true)
          setStatusRichiestaPreventivoThankYouModal(status)
        }}
        utentePrivato={false}
      />
      <RichiestaPreventivoThankYouModal
        open={openRichiestaPreventivoThankYouModal}
        setOpen={setOpenRichiestaPreventivoThankYouModal}
        status={statusRichiestaPreventivoThankYouModal}
      />
    </div>
  )
}

export default Page
